export default {
    props: {
        alignment: String,
        config: {
            type: Object,
            default: () => ({})
        },
        l10n: {
            type: Object,
            default: () => ({})
        },
        placeholder: {
            type: String,
            default: 'Pick date'
        },
        inputClass: {
            type: Object,
            default: () => ({})
        },
        clearTooltip: String,
        value: String
    },

    computed: {
        date: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit('input', newValue);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/App/protected/components/banet-datetime-picker/plugins/VueBulmaDatepicker/BaseInput.js